import React, {useState, useRef, useEffect} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import {useAuth} from '../Auth/AuthContext';
import Topbar from './Topbar';

// Icons as SVG components
const SearchIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="8"/>
        <path d="m21 21-4.35-4.35"/>
    </svg>
);

const HomeIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
        <polyline points="9,22 9,12 15,12 15,22"/>
    </svg>
);

const DashboardIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="7" height="7"/>
        <rect x="14" y="3" width="7" height="7"/>
        <rect x="14" y="14" width="7" height="7"/>
        <rect x="3" y="14" width="7" height="7"/>
    </svg>
);

const InboxIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="22,12 16,12 14,15 10,15 8,12 2,12"/>
        <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>
    </svg>
);

const DocumentIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14,2 14,8 20,8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
    </svg>
);

const SettingsIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
);

const EditorIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
    </svg>
);

const BlogIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
    </svg>
);

const ProfileIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
    </svg>
);

const DesignerIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10"/>
        <circle cx="12" cy="10" r="3"/>
        <path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"/>
    </svg>
);

const MyPagesIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
        <line x1="3" y1="9" x2="21" y2="9"/>
        <line x1="9" y1="21" x2="9" y2="9"/>
    </svg>
);
const BrandsIcon = () => (    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20 7h-4M4 7h4m0 0v12m0-12l4-4m-4 4l4 4M16 7v12m0 0l-4-4m4 4l4-4"/>
    </svg>
);

const OrdersIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <path d="M16 10a4 4 0 0 1-8 0"/>
    </svg>
);

const TransactionsIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="12" y1="1" x2="12" y2="23"/>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
    </svg>
);

const AnalyticsIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="18" height="18" rx="3" />
        <path d="M7 16v-4M12 16V8M17 16v-6" />
    </svg>
);

const LogoutIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
        <polyline points="16,17 21,12 16,7"/>
        <line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
);

const ChevronIcon = ({isOpen}) => (
    <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        style={{
            transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease'
        }}
    >
        <polyline points="9,18 15,12 9,6"/>
    </svg>
);

const CollapseIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="11 17 6 12 11 7"/>
        <polyline points="18 17 13 12 18 7"/>
    </svg>
);

const HamburgerIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="3" y1="6" x2="21" y2="6"/>
        <line x1="3" y1="12" x2="21" y2="12"/>
        <line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
);

const PlusIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="12" y1="5" x2="12" y2="19"/>
        <line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
);

export default function Sidebar({children}) {
    const [sidebarWidth, setSidebarWidth] = useState(() => {
        const saved = localStorage.getItem('koenig-sidebar-width');
        return saved ? parseInt(saved, 10) : 240;
    });
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isHovering, setIsHovering] = useState(false);
    const [isResizing, setIsResizing] = useState(false);
    const [privateOpen, setPrivateOpen] = useState(true);
    const [sharedOpen, setSharedOpen] = useState(true);
    const sidebarRef = useRef(null);
    const overlayRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const {user, logout} = useAuth();

    const minWidth = 200;
    const maxWidth = 400;
    const collapsedWidth = 0;

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (!isResizing) {return;}
            const newWidth = e.clientX;
            if (newWidth >= minWidth && newWidth <= maxWidth) {
                setSidebarWidth(newWidth);
                localStorage.setItem('koenig-sidebar-width', newWidth.toString());
            }
        };

        const handleMouseUp = () => {
            setIsResizing(false);
            document.body.style.cursor = 'default';
            document.body.style.userSelect = 'auto';
        };

        if (isResizing) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            document.body.style.cursor = 'col-resize';
            document.body.style.userSelect = 'none';
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isResizing]);

    const handleMouseDown = (e) => {
        e.preventDefault();
        setIsResizing(true);
    };

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const isActive = (path) => location.pathname === path || location.hash === `#${path}`;

    const MenuItem = ({icon, label, path, onClick}) => (
        <div
            onClick={onClick || (() => navigate(path))}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '6px 12px',
                marginBottom: '2px',
                borderRadius: '6px',
                cursor: 'pointer',
                backgroundColor: isActive(path) ? 'rgba(0,0,0,0.05)' : 'transparent',
                color: '#37352f',
                fontSize: '14px',
                fontFamily: "'Inter', sans-serif",
                transition: 'background-color 0.1s ease'
            }}
            onMouseEnter={(e) => {
                if (!isActive(path)) {
                    e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.03)';
                }
            }}
            onMouseLeave={(e) => {
                if (!isActive(path)) {
                    e.currentTarget.style.backgroundColor = 'transparent';
                }
            }}
        >
            <span style={{color: '#91918e', display: 'flex', alignItems: 'center'}}>
                {icon}
            </span>
            <span>{label}</span>
        </div>
    );

    const SectionHeader = ({label, isOpen, onToggle, onAdd}) => (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px 12px 4px 12px',
                marginTop: '8px'
            }}
        >
            <div
                onClick={onToggle}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: '500',
                    color: '#91918e',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    fontFamily: "'Inter', sans-serif"
                }}
            >
                <ChevronIcon isOpen={isOpen} />
                {label}
            </div>
            {onAdd && (
                <div
                    onClick={onAdd}
                    style={{
                        cursor: 'pointer',
                        color: '#91918e',
                        padding: '2px',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.05)'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                    <PlusIcon />
                </div>
            )}
        </div>
    );

    return (
        <div style={{display: 'flex', minHeight: '100vh', backgroundColor: '#ffffff', position: 'relative', overflowX: 'hidden', width: '100%', boxSizing: 'border-box'}}>
            {/* Sidebar Overlay (visible on hover when collapsed) - starts below hamburger */}
            {isCollapsed && (
                <div
                    ref={overlayRef}
                    onMouseEnter={() => setIsHovering(true)}
                    onMouseLeave={() => setIsHovering(false)}
                    style={{
                        position: 'fixed',
                        left: 0,
                        top: '56px', // Start below the hamburger icon area
                        bottom: 0,
                        width: isHovering ? `${sidebarWidth}px` : '4px',
                        backgroundColor: isHovering ? '#fff' : 'transparent',
                        borderRight: isHovering ? '1px solid rgba(0,0,0,0.05)' : 'none',
                        boxShadow: isHovering ? '2px 0 8px rgba(0, 0, 0, 0.05)' : 'none',
                        zIndex: 999,
                        transition: 'width 0.25s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.25s ease, box-shadow 0.25s ease',
                        pointerEvents: isHovering ? 'auto' : 'auto',
                        fontFamily: "'Inter', sans-serif"
                    }}
                >
                    {isHovering && (
                        <div style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            overflow: 'hidden'
                        }}>
                            {/* Main Menu - starts directly since header is above with hamburger */}
                            <div style={{padding: '8px', flex: 1, overflowY: 'auto'}}>
                                <MenuItem icon={<DashboardIcon />} label="Dashboard" path="/dashboard" />
                                <MenuItem icon={<MyPagesIcon />} label="My Pages" path="/my-pages" />
                                <MenuItem icon={<BrandsIcon />} label="Brands" path="/brands" />
                                <MenuItem icon={<OrdersIcon />} label="Orders" path="/orders" />
                                <MenuItem icon={<TransactionsIcon />} label="Transactions" path="/transactions" />
                                <MenuItem icon={<AnalyticsIcon />} label="Overview" path="/financial-dashboard" />
                            </div>

                            {/* Bottom Section */}
                            <div style={{
                                padding: '8px',
                                borderTop: '1px solid rgba(0,0,0,0.05)'
                            }}>
                                <MenuItem icon={<SettingsIcon />} label="Settings" path="/settings" />
                                <MenuItem
                                    icon={<LogoutIcon />}
                                    label="Log out"
                                    onClick={handleLogout}
                                />
                            </div>
                        </div>
                    )}
                </div>
            )}

            {/* Sidebar - Always rendered, animated with transform */}
            <div
                ref={sidebarRef}
                style={{
                    width: `${sidebarWidth}px`,
                    minWidth: `${sidebarWidth}px`,
                    maxWidth: `${sidebarWidth}px`,
                    height: '100vh',
                    backgroundColor: '#fff',
                    borderRight: '1px solid rgba(0,0,0,0.05)',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    fontFamily: "'Inter', sans-serif",
                    transform: isCollapsed ? `translateX(-${sidebarWidth}px)` : 'translateX(0)',
                    opacity: isCollapsed ? 0 : 1,
                    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease',
                    pointerEvents: isCollapsed ? 'none' : 'auto',
                    zIndex: 100
                }}
            >
                    {/* User Profile Header */}
                    <div style={{
                        padding: '12px',
                        borderBottom: '1px solid rgba(0,0,0,0.05)'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                cursor: 'pointer',
                                padding: '4px 8px',
                                borderRadius: '6px',
                                flex: 1
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.03)'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                            >
                            <img 
                                src="/images/optimus-icon.png" 
                                alt="Optimus" 
                                style={{
                                    width: '22px',
                                    height: '22px',
                                    borderRadius: '4px'
                                }}
                            />
                            <span style={{
                                fontSize: '20px',
                                fontWeight: '600',
                                color: '#37352f',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}>
                                Optimus
                            </span>
                            </div>
                            <div
                                onClick={() => {
                                    setIsHovering(false); // Reset hover state when collapsing
                                    setIsCollapsed(true);
                                }}
                                style={{
                                    cursor: 'pointer',
                                    padding: '4px',
                                    borderRadius: '4px',
                                    color: '#91918e',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.05)'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                title="Collapse sidebar"
                            >
                                <CollapseIcon />
                            </div>
                        </div>
                    </div>

                    {/* Main Menu */}
                    <div style={{padding: '8px', flex: 1, overflowY: 'auto'}}>
                        <MenuItem icon={<DashboardIcon />} label="Dashboard" path="/dashboard" />
                        {/* <MenuItem icon={<AnalyticsIcon />} label="Overview" path="/financial-dashboard" /> */}
                        <MenuItem icon={<MyPagesIcon />} label="My Pages" path="/my-pages" />
                        <MenuItem icon={<BrandsIcon />} label="Brands" path="/brands" />
                        <MenuItem icon={<OrdersIcon />} label="Orders" path="/orders" />
                        <MenuItem icon={<TransactionsIcon />} label="Transactions" path="/transactions" />
                    </div>

                    {/* Bottom Section */}
                    <div style={{
                        padding: '8px',
                        borderTop: '1px solid rgba(0,0,0,0.05)'
                    }}>
                        <MenuItem icon={<SettingsIcon />} label="Settings" path="/settings" />
                        <MenuItem
                            icon={<LogoutIcon />}
                            label="Log out"
                            onClick={handleLogout}
                        />
                    </div>

                    {/* Resize Handle */}
                    <div
                        onMouseDown={handleMouseDown}
                        style={{
                            position: 'absolute',
                            right: 0,
                            top: 0,
                            bottom: 0,
                            width: '4px',
                            cursor: 'col-resize',
                            backgroundColor: isResizing ? 'rgba(0,0,0,0.1)' : 'transparent',
                            transition: 'background-color 0.2s ease'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.08)'}
                        onMouseLeave={(e) => {
                            if (!isResizing) {
                                e.currentTarget.style.backgroundColor = 'transparent';
                            }
                        }}
                    />
                </div>

            {/* Hamburger Icon (when collapsed) - Always visible, triggers overlay on hover */}
            <div
                onClick={() => setIsCollapsed(false)}
                onMouseEnter={() => {
                    if (isCollapsed) {
                        setIsHovering(true);
                    }
                }}
                style={{
                    position: 'fixed',
                    left: '12px',
                    top: '12px',
                    width: '32px',
                    height: '32px',
                    backgroundColor: isHovering ? '#fff' : '#fff',
                    border: '1px solid rgba(0,0,0,0.1)',
                    borderRadius: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    color: '#91918e',
                    zIndex: 1000,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    opacity: isCollapsed ? 1 : 0,
                    transform: isCollapsed ? 'translateX(0)' : 'translateX(-20px)',
                    pointerEvents: isCollapsed ? 'auto' : 'none',
                    transition: 'opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1), transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.15s ease'
                }}
                title={isHovering ? "Lock sidebar open" : "Open sidebar"}
            >
                <HamburgerIcon />
            </div>

            {/* Main Content: Topbar + Page */}
            <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                backgroundColor: '#fbfaf8',
                transition: 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                minWidth: 0,
                maxWidth: '100%',
                marginLeft: isCollapsed ? 0 : `${sidebarWidth}px`
            }}>
                {/* <Topbar /> */}
                <div style={{ flex: 1, overflow: 'auto', overflowX: 'hidden' }}>
                    {children}
                </div>
            </div>

        </div>
    );
}
